import React from 'react'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  currentUserCardHeader: {
    '& .MuiCardHeader-action': {
      alignSelf: 'center',
      margin: 0,
    },
  },
}))

const CurrentUserCard = ({ currentUser, action }) => {
  const classes = useStyles()
  return (
    <Card variant="outlined">
      <CardHeader
        className={classes.currentUserCardHeader}
        avatar={
          <Avatar />
        }
        action={action}
        title={`${currentUser.firstName} ${currentUser.lastName}`}
        subheader={currentUser.email}
      />
    </Card>
  )
}

export default CurrentUserCard
